import { GenericalRecord } from '@eastcoal/common/types/utilities'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { CrudFormStoreContext } from '../context/StoreContext'
import { CrudFormStore } from '../store/interface'

export const useCrudFormStore = <StateSlice>(
  selector: (
    state: CrudFormStore<GenericalRecord, GenericalRecord, GenericalRecord>
  ) => StateSlice
) => {
  return useContextStore(CrudFormStoreContext, selector)
}

export const useCrudFormStoreApi = () => {
  return useContextStoreApi(CrudFormStoreContext)
}
